module.exports = __webpack_public_path__ + "static/media/web03_eng.64268560.png";